import { Outlet } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useAuthContext } from "../hooks/useAuthContext";

function RequireAuthorization({role}) {
  const [authorization, setAuthorization] = useState(0);
  const { user, dispatch } = useAuthContext();
  let cnt = useRef(0);

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const response = await fetch("/api/v1/" + role, {
          method: "GET",
          headers: { Authorization: `Bearer ${user.token}` },
        });

        if (response.ok) {
          setAuthorization(2);
        } else {
          if (response.status === 401) {
            localStorage.removeItem("user");
            dispatch({ type: "LOGOUT" });
          }
          setAuthorization(1);
          throw new Error(response.error);
        }
      } catch (error) {
        console.log(error);
      }
    };

    //if (cnt.current) {
      fetchAdmin();
    //}

    cnt.current += 1;
  }, []);

  if (authorization === 1) {
    return <Navigate to="/404" />;
  }

  return authorization === 2 ? <Outlet /> : <></>
}

export default RequireAuthorization;
